import React from 'react';
import { getUserRole, clearAuth } from '../Utils';
import './Header.css';

interface HeaderProps {
  title?: string;
  translations?: Record<string, string>;
}

const Header: React.FC<HeaderProps> = ({ title, translations = {} }) => {
  const role = getUserRole();
  const loggedIn = role !== 'anonymous';

  return (
    <header className="app-header">
      <nav className="header-nav">
        <div className="nav-left">
          <a href="/" className="nav-brand">Amovent</a>
          {loggedIn && <a href="/diary" className="nav-link">{translations["nav.diary"]}</a>}
          {loggedIn && <a href="/users" className="nav-link">{translations["nav.users"]}</a>}
          {loggedIn && <a href="/user0/dialogs" className="nav-link">{translations["nav.dialogs"]}</a>}
          <a href="/events" className="nav-link">{translations["nav.events"]}</a>
          <a href="/place" className="nav-link">{translations["nav.places"]}</a>
        </div>

        {title && <h1 className="header-title">{title}</h1>}

        <div className="nav-right">
          {loggedIn && <a href="/settings" className="nav-link">{translations["nav.settings"]}</a>}
          {role === 'admin' && <a href="/admin" className="nav-link">{translations["nav.administration"]}</a>}
          {loggedIn ? (
            <a href="/" className="nav-link" onClick={() => clearAuth()}>{translations["nav.logout"]}</a>
          ) : (
            <a href="/login" className="nav-link">{translations["nav.login"]}</a>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;